
import {sQuery as sq} from './sq.js';
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		//name: 'sQuery - Native speed jQuery for Svelte'
	}
});

export default app;